export default "__VITE_ASSET__C5y9bVFv__"